export default __webpack_public_path__ + "77f61257ea5143c47e12f3f66b0c526e.png";